import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';

const PackButton = ({
  navigateTo = '/v2/home',
  className = '',
  iconSize = 24,
  buttonSize = 'w-11 h-11',
  showOnDesktop = false, // Option to force show on desktop if needed
}) => {
  const router = useNavigate();
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;

      // Mobile: width <= 768px
      const isMobile = width <= 768;

      // Tablet Portrait: 768px < width <= 1366px and height > width
      const isTabletPortrait = width > 768 && width <= 1366 && height > width;

      // Tablet Horizontal: width between 800-1366px and width > height
      const isTabletHorizontal = width >= 800 && width <= 1366 && width > height;

      // Desktop: width > 1366px
      const isDesktop = width > 1366;

      // Show button on mobile, tablet portrait, tablet horizontal
      // Only hide on desktop unless showOnDesktop is true
      const shouldShowButton = isMobile || isTabletPortrait || isTabletHorizontal || (isDesktop && showOnDesktop);

      setShouldShow(shouldShowButton);
    };

    checkDevice();
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, [showOnDesktop]);

  const handleClick = () => {
    router(navigateTo);
  };

  // Don't render anything if button shouldn't be shown
  if (!shouldShow) {
    return null;
  }

  return (
    <div className={`mb-4 ${className}`}>
      <button
        onClick={handleClick}
        className={`flex items-center justify-center ${buttonSize} rounded-[56px] cursor-pointer`}
        style={{
          background: 'var(--q3-surface-dimmer)',
        }}
      >
        <ArrowLeft size={iconSize} color="var(--q3-neutral-default)" />
      </button>
    </div>
  );
};

export default PackButton;
